<template>
  <div>
    <patient-header></patient-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, 0.9); margin-top: 200px">
      <v-container class="site-padding" id="aboutActionSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">o akcji</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--patients"></div>
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-left">
            <!--            <div>-->
            <!--                  <span class="patients-container&#45;&#45;sections text-capitalize">Polskie Towarzystwo Okulistyczne</span>-->
            <!--                  <span>zaprasza pacjentów na piątą edycję bezpłatnych badań profilaktycznych w kierunku jaskry, w ramach </span>-->
            <!--                  <span class="patients-container&#45;&#45;sections text-capitalize">Światowego Tygodnia Jaskry,</span>-->
            <!--                  <span>które odbędą się między </span>-->
            <!--                  <span class="patients-container&#45;&#45;sections text-lowercase">7, a 13 marca 2021</span>-->
            <!--                  <span>roku na terenie całej Polski.</span>-->
            <!--            </div>-->
            <!--            <div class="pt-2">-->
            <!--              <span>Jest to międzynarodowa inicjatywa lekarzy okulistów mająca na celu podniesienie świadomości społeczeństwa na temat jaskry oraz zwiększenie jej wykrywalności we wczesnych stadiach zaawansowania.</span>-->
            <!--            </div>-->
            <div class="mb-3">
              <span class="patients-container--sections text-uppercase"
                >„Polscy Okuliści Kontra Jaskra”</span
              >
              to akcja bezpłatnych badań profilaktycznych w kierunku jaskry, 
              organizowana przez Polskie Towarzystwo Okulistyczne w ramach
              <span class="patients-container--sections text-uppercase"
                >Światowego Tygodnia Jaskry</span
              >. Jest to inicjatywa lekarzy okulistów mająca na celu podniesienie świadomości społeczeństwa na temat 
              jaskry oraz zwiększenie jej wykrywalności we wczesnych stadiach zaawansowania.
            </div>

            <div>
              Akcja badań trwa
              <span class="patients-container--sections text-uppercase"
                >od niedzieli 8 marca do soboty 14 marca 2026 r.</span
              >. Każdy z gabinetów decyduje, w jakich dniach i godzinach będzie przeprowadzał 
              badania i ile miejsc może udostępnić. Liczba miejsc jest ograniczona. Decyduje kolejność zgłoszeń. 
              Polskie Towarzystwo Okulistyczne nie odpowiada za liczbę miejsc i dostępność wizyt w poszczególnych placówkach.
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-padding" id="whyWorthSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">
              dlaczego warto?
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--patients"></div>
            </div>
          </v-flex>

          <v-flex xs12 class="text-xs-left">
            <div>
              Problem jaskry w Polsce może dotyczyć nawet
              <span class="patients-container--sections">800 TYS. OSÓB</span
              >, przy czym tylko połowa została zdiagnozowana. W 90 proc.
              przypadków choroba przebiega bez widocznych dolegliwości
              i zachorować może każdy bez względu na wiek i płeć.
              Tymczasem tylko wczesna diagnoza jaskry może pomóc ocalić wzrok.
              Dlatego tak ważne są regularne badania.<br />
              <span class="patients-container--sections"
                >KAŻDY POWINIEN PRZYNAJMNIEJ RAZ NA DWA LATA PRZEJŚĆ PEŁNE
                BADANIE OKULISTYCZNE</span
              >, a osoby z grupy ryzyka nawet co 12 miesięcy.
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-padding" id="riskSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">
              grupa ryzyka
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--patients"></div>
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-left">
            <div>
              Do podstawowych czynników ryzyka zachorowania na jaskrę zalicza
              się między innymi: wiek powyżej 40. roku życia, choroby
              kardiologiczne, obecność jaskry w rodzinie, zaburzenia krążenia
              obwodowego, życie w ciągłym stresie i bóle głowy. Niezależnie od
              głównych czynników profilaktyczne badanie w kierunku tej choroby
              zalecane jest każdej osobie, która od roku nie była u okulisty.
              Wykrycie jaskry we wczesnych stadiach zaawansowania jest bardzo
              ważne, ponieważ rozpoczęcie leczenia w odpowiednim czasie pozwala
              uniknąć całkowitej utraty wzroku.
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-padding" id="institutionSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">
              Sukcesy poprzednich edycji Polscy Okuliści Kontra Jaskra 2017-2025:
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--patients"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-2">
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <span
                      style="font-size: 2.6rem; line-height: 1; font-weight: 700; color: #fff"
                    >
                      20 tys.
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="patients-container--sections">przebadanych</span>
                    <span class="patients-container--sections">Polaków</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <span
                      style="font-size: 2.6rem; font-weight: 700; color: #fff"
                    >
                      40%
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="patients-container--sections">Pacjentów skierowanych</span>
                    <span class="patients-container--sections">do dalszej diagnostyki</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <span
                      style="font-size: 2.6rem; font-weight: 700; color: #fff"
                    >
                      400
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="patients-container--sections">gabinetów</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <span
                      style="font-size: 2.6rem; line-height: 1; font-weight: 700; color: #fff"
                    >
                      30,5 mln
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="ban2"></span>
                    <span
                      class="patients-container--sections patients-container--sections-blue"
                      >odbiorców akcji edukacyjnej</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container>
        <v-layout row v-if="isInstitutionsBtnShown" class="mb-3">
          <v-flex xs12 sm6>
            <my-button
              toName="Institutions"
              title="Znajdź gabinet"
              text="<span>Znajdź <br>gabinet</span>"
              customClass="patient rect-x1"
            />
          </v-flex>
        </v-layout>
      </v-container>

      <!--      <v-container class="site-padding">-->
      <!--        <v-layout align-center justify-center row wrap class="patients-container">-->
      <!--          <v-flex xs12 class="text-xs-left">-->
      <!--            <div>-->
      <!--              <span>Zapraszamy na kolejną edycję akcji w marcu 2022 roku.</span>-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--        </v-layout>-->
      <!--      </v-container>-->

      <v-container class="site-padding" id="faqSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container mb-3"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">faq</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--patients"></div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="mb-3">
            <h3 class="patients-container--sections">
              1. Gdzie znajdę listę gabinetów? 
            </h3>
            <span
              >Lista dostępna będzie od dnia 3 marca 2026 r. od godz. 12.00</span
            >
          </v-flex>
          <v-flex xs12 class="mb-3">
            <h3 class="patients-container--sections">
              2. Ile kosztuje wizyta?
            </h3>
            <span
              >Badania są bezpłatne dla pacjentów, którzy zarejestrowali się na
              wizytę telefonicznie w&nbsp;terminach wskazanych przez gabinet.
              Gabinet może zaproponować odpłatnie dodatkowe badania, nieobjęte
              zakresem usługi badań przesiewowych, w&nbsp;ramach których powinny
              być przeprowadzone: pomiar ciśnienia i&nbsp;badanie dna oka.</span
            >
          </v-flex>
          <v-flex xs12 class="mb-3">
            <h3 class="patients-container--sections">
              3. Kiedy przyjmują gabinety?
            </h3>
            <span
              >Akcja bezpłatnych badań jest prowadzona w dniach 8-14 marca 2026 r. Dokładne terminy wizyt są indywidualnie 
              ustalane przez każdą placówkę. Aby sprawdzić godziny przyjęć, znajdź gabinet w Twojej 
              okolicy i zobacz, w jakich godzinach przyjmuje. Następnie zarezerwuj wizytę telefonicznie.</span
            >
          </v-flex>
          <v-flex xs12 class="mb-3">
            <h3 class="patients-container--sections">
              4. ILE OSÓB BĘDZIE MOGŁO SKORZYSTAĆ Z BADANIA?
            </h3>
            <span
              >Tegoroczna akcja badań trwa od niedzieli 8 marca do soboty 14 marca. 
              Każdy z gabinetów decyduje, w jakich dniach i godzinach będzie przeprowadzał 
              badania i ile miejsc może udostępnić. Liczba miejsc jest ograniczona. Decyduje kolejność zgłoszeń. 
              Polskie Towarzystwo Okulistyczne nie odpowiada za liczbę miejsc i dostępność wizyt w poszczególnych placówkach.
            </span>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-bottom-padding" id="contactSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">kontakt</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle--patients"></div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class>
            <h3 class="patients-container--sections">
              Jeśli masz pytania, skontaktuj się z nami!
            </h3>
          </v-flex>
        </v-layout>

        <v-form
          ref="form"
          id="needs-validation"
          v-model="valid"
          lazy-validation
          class="pt-3"
        >
          <v-container>
            <v-layout
              align-baseline
              justify-center
              row
              wrap
              class="register-form"
            >
              <v-flex xs12 md6 class="text-xs-left px-md-3 px-2">
                <v-text-field
                  label="Imię i Nazwisko"
                  solo
                  v-model="form.name"
                  :rules="nameRules"
                ></v-text-field>
                <v-text-field
                  label="Telefon"
                  solo
                  v-model="form.phone"
                  mask="###########"
                  :rules="nameRules"
                ></v-text-field>
                <v-text-field
                  label="E-mail"
                  solo
                  v-model="form.email"
                  :rules="emailRules"
                ></v-text-field>
                <v-textarea
                  class="register-form--noShadow register-form--spacing"
                  label="Wiadomość"
                  solo
                  full-width
                  rows="12"
                  no-resize
                  v-model="form.message"
                  :rules="nameRules"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-left px-md-3 px-4">
                <h3 class="patients-container--sections">
                  Sekretariat Polskiego Towarzystwa Okulistycznego
                </h3>
                <div class="pt-3">
                  Katedra Okulistyki Wydziału Nauk Medycznych w Katowicach
                </div>
                <div>Śląski Uniwersytet Medyczny w Katowicach</div>
                <div class="pt-3">ul. Ceglana 35</div>
                <div>40-514 Katowice</div>
                <div class="pt-3">
                  tel.: 570 960 004
                </div>                
              </v-flex>
              <v-flex
                xs12
                class="text-xs-left px-md-3 px-2"
                id="bulletsSection"
              >
                <div class="two-column">
                  <div class="single-col">
                    <div class="styled-input-container styled-input--rounded">
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted1"
                          v-validate="'required'"
                          data-vv-name="form.accepted1"
                          data-vv-as="zgody"
                          name="accepted"
                          id="checkbox3-example-one"
                        />
                        <label for="checkbox3-example-one">
                          Wyrażam zgodę na przetwarzanie przez firmę Compass
                          Public Relations s.c. K. Waligóra, A. Pawlikowska z
                          siedzibą w Warszawie przy ul. Chłodnej 64 lok. 223,
                          kod: 00-872 moich danych osobowych zawartych
                          w&nbsp;formularzu rejestracyjnym w&nbsp;celu
                          i&nbsp;zakresie niezbędnym do rejestracji na
                          wydarzenie organizowane przez firmę Compass Public
                          Relations s.c. K. Waligóra, A. Pawlikowska.
                          <br /><br />W związku z&nbsp;wejściem nowego
                          rozporządzenia Unii Europejskiej o&nbsp;ochronie
                          danych osobowych tzw. RODO wyrażam zgodę na
                          przetwarzanie moich danych osobowych zawartych
                          w&nbsp;niniejszym zgłoszeniu dla potrzeb niezbędnych
                          do informowania o&nbsp;Konferencjach i&nbsp;Zjazdach
                          organizowanych przez firmę Compass Public Relations
                          s.c. K. Waligóra, A. Pawlikowska z siedzibą w
                          Warszawie przy ul. Chłodnej 64 lok. 223, kod: 00-872
                          (zgodnie z&nbsp;Rozporządzeniem Parlamentu
                          Europejskiego i&nbsp;Rady (UE) 2016/679 - RODO/GDPR
                          z&nbsp;dnia 27 kwietnia 2016 roku, ustawy
                          o&nbsp;ochronie danych osobowych z&nbsp;dnia 10 maja
                          2018 r.).
                        </label>
                        <div class="v-messages__wrapper error--text">
                          <i
                            v-show="errors.has('form.accepted1')"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('form.accepted1')"
                            class="v-messages__message v-messages"
                            >{{ errors.first("form.accepted1") }}</span
                          >
                        </div>
                      </div>
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted2"
                          name="accepted2"
                          id="checkbox3-example-two"
                        />
                        <label for="checkbox3-example-two">
                          Wyrażam zgodę na przesyłanie mi informacji handlowych
                          środkami komunikacji elektronicznej przez: Polskie
                          Towarzystwo Okulistyczne z&nbsp;siedzibą
                          w&nbsp;Warszawie oraz podmioty współpracujące
                          w&nbsp;szczególności firmę Compass Public Relations
                          s.c. K. Waligóra, A. Pawlikowska z siedzibą w
                          Warszawie przy ul. Chłodnej 64 lok. 223, kod: 00-872,
                          zgodnie z&nbsp;ustawą z&nbsp;dnia 18 lipca
                          2002&nbsp;r. o&nbsp;świadczeniu usług drogą
                          elektroniczną (Dz.&nbsp;U. z&nbsp;2002&nbsp;r.
                          Nr&nbsp;144, poz. 1204 z&nbsp;późn. zm.). Wyrażam
                          zgodę na przetwarzanie moich danych osobowych przez
                          Polskie Towarzystwo Okulistyczne z&nbsp;siedzibą
                          w&nbsp;Warszawie w&nbsp;celach marketingowych oraz na
                          przekazywanie mi propozycji zawarcia umowy przy użyciu
                          telefonu zgodnie z&nbsp;Ustawą z&nbsp;dnia
                          16&nbsp;lipca 2004&nbsp;r. Prawo telekomunikacyjne
                          (tj. Dz.&nbsp;U. z&nbsp;2014&nbsp;r. poz. 243).
                          <br />Oświadczam, że zostałam(em) poinformowana(y)
                          o&nbsp;prawie wglądu do moich danych
                          i&nbsp;dokonywaniu ich zmian.
                        </label>
                      </div>
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted3"
                          v-validate="'required'"
                          data-vv-name="form.accepted3"
                          data-vv-as="zgody"
                          name="accepted3"
                          id="checkbox3-example-three"
                        />
                        <label for="checkbox3-example-three">
                          Akceptuję
                          <router-link
                            :to="{ name: 'Regulations' }"
                            class="doctors-container--links"
                            >regulamin.
                          </router-link>
                        </label>
                        <div class="v-messages__wrapper error--text">
                          <i
                            v-show="errors.has('form.accepted3')"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('form.accepted3')"
                            class="v-messages__message v-messages"
                            >{{ errors.first("form.accepted3") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row class="mb-3" @click="submit">
              <v-flex class="xs12 sm6">
                <my-button
                  toName="Patients"
                  title="Wyślij wiadomość"
                  text="<span>Wyślij <br>wiadomość</span>"
                  customClass="patient rect-x1"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-container>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3 class="patients-container--sections">
              Dziękujemy za wiadomość.
            </h3>
            <h4>Twoja wiadomość została przekazana do organizatora.</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="header-separator" style="height: 50px"></div>
  </div>
</template>

<script>
import MyButton from "@/components/partials/Button";
import PatientHeader from "@/components/partials/PatientHeader";
import moment from "moment";
import VueScrollTo from "vue-scrollto";

export default {
  name: "Homepage",
  data() {
    return {
      dialog: false,
      valid: true,
      time: "",
      form: [
        {
          id: "first_name",
          model: "first_name",
          type: "text",
          name: "first_name",
        },
        { id: "phone", model: "phone", type: "text", name: "phone" },
        { id: "email", model: "email", type: "text", name: "email" },
        { id: "message", model: "message", type: "text", name: "comment" },
      ],
      nameRules: [(v) => !!v || "Pole jest wymagane"],
      emailRules: [
        (v) => !!v || "E-mail jest wymagany",
        (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            v
          ) || "Zły format",
      ],
      institutions_number: "",
      cities_number: "",
      states_number: "",
      patients_number: "",
      institutions_number_now: "",
      cities_number_now: "",
      states_number_now: "",
      patients_number_now: "",
    };
  },
  components: {
    MyButton,
    PatientHeader,
  },
  watch: {
    $route: function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      }
    },
  },
  mounted() {
    if (this.$route.hash) {
      this.scrollToSection(this.$route.hash);
    }
  },
  beforeMount() {
    this.fetchInstitutions();
    this.fetchCities();
    this.fetchPatients();
    this.fetchStates();
    this.fetchInstitutionsNow();
    this.fetchCitiesNow();
    this.fetchPatientsNow();
    this.fetchStatesNow();
  },
  methods: {
    scrollToSection(section) {
      const options = {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: -200,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true,
      };

      VueScrollTo.scrollTo(section, 300, options);
    },
    fetchInstitutions() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-institutions`,
      }).then((result) => {
        this.institutions_number = result.data;
      });
    },
    fetchStates() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-states`,
      }).then((result) => {
        this.states_number = result.data;
      });
    },
    fetchCities() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-cities`,
      }).then((result) => {
        this.cities_number = result.data;
      });
    },
    fetchPatients() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-patients`,
      }).then((result) => {
        this.patients_number = result.data;
      });
    },
    fetchInstitutionsNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-institutions-now`,
      }).then((result) => {
        this.institutions_number_now = result.data;
      });
    },
    fetchStatesNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-states-now`,
      }).then((result) => {
        this.states_number_now = result.data;
      });
    },
    fetchCitiesNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-cities-now`,
      }).then((result) => {
        this.cities_number_now = result.data;
      });
    },
    fetchPatientsNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-patients-now`,
      }).then((result) => {
        this.patients_number_now = result.data;
      });
    },
    findInstitution() {
      this.$router.push({
        name: "Institutions",
      });
    },
    clearForm() {
      this.form.name = "";
      this.form.phone = "";
      this.form.email = "";
      this.form.message = "";
      this.form.accepted1 = null;
      this.form.accepted2 = null;
      this.form.accepted3 = null;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.isDisabled = true;
            const data = {
              form: {
                name: this.form.name,
                email: this.form.email,
                phone: this.form.phone,
                message: this.form.message,
                accepted1: this.form.accepted1,
                accepted2: this.form.accepted2,
                accepted3: this.form.accepted3,
              },
            };

            this.clearForm();
            this.$refs.form.reset();

            this.axios({
              method: "POST",
              url: `${process.env.APP_URL}/api/send`,
              data: data,
            })
              .then((response) => {
                this.isDisabled = false;

                this.clearForm();
                this.$refs.form.reset();

                this.dialog = true;
              })
              .catch((response) => {
                this.isDisabled = false;
                Object.keys(response.response.data.errors).map((key) =>
                  response.response.data.errors[key].map((error) =>
                    this.showErrors(error)
                  )
                );
              });
          } else {
            this.scrollToSection("#bulletsSection");
          }
        });
      } else {
        this.scrollToSection("#contactSection");
      }
    },
  },
  computed: {
    isInstitutionsBtnShown() {
      const showDate = "2026-03-03 12:00:00";

      if (moment().isAfter(showDate)) {
        return true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.patients-container {
  font-size: 1.4rem;
}

.x1 {
  overflow: hidden;
  width: 250px;
  height: 100px;
  position: relative;
}

.x1 .x2 {
  display: inline-block;
  float: left;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -khtml-border-radius: 50%;
  text-align: center;
  position: relative;
}

.x1-bg {
  background: #9a1c1e;
}

.x2-bg {
  background: #275271;
}

.x1 .x2 span {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 35px;
  height: 35px;
  font-size: 35px;
  overflow: hidden;
  color: #ffffff;
  font-weight: 900;
}

.x1--text {
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 50%;
}

.timer-container--header {
  font-size: 26px;
  color: #9a1c1e;
  text-align: left;
  font-weight: 900;
  font-family: 'Fira Sans', sans-serif;
}

.timer-container--wrapper {
  width: 100%;
  margin: 0 auto;
}

.statsCircle {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 0;
  padding: 50% 0;
  border-radius: 50%;
  /* Just making it pretty */
  background: #9a1c1e;
  color: white;
  font-family: Helvetica, Arial Black, sans;
  font-size: 48px;
  text-align: center;
}

.term-container--position {
  align-items: baseline !important;
}

.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}

.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}

.banner {
  background-color: transparent;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: 'Fira Sans', sans-serif;
  text-align: left;
  color: #aaa;
  display: block;
  vertical-align: middle;
}

.banner img {
  float: left;
}

.time-container {
  display: inline-flex;
  width: 100%;
}

.time-container--separator {
  width: 145px;
  padding-right: 5px;
}

.patients-container--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}

.patients-container--links {
  color: #a41611;
  font-family: 'Fira Sans', sans-serif;
}

.patients-container--sections {
  color: #a41611;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}

.patients-container--sections-brown {
  color: #a41611;
}

.patients-container--sections-blue {
  color: #275271 !important;
}

.patients-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}

.patients-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 1200px;
  line-height: 120px;
  border: none;
  padding: 20px;
}

.patients-container--icons-brown {
  background: #a82824;
}

.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}

.sparator-rectangle--patients {
  width: 115px;
  height: 8px;
  background-color: #a82824;
}

.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}

.patient-bg {
  position: relative;
}

.patient-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: '';
  position: fixed;
  opacity: 0.1;
  background-image: url('/static/images/bg-main.jpg');
  background-repeat: repeat;
  background-position: center center;
}

.patient-header {
  background: #a82824;
  opacity: 0.9;
}

.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}

.free-main-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
}

.main-header--wgw {
  width: 125px;
}

.main-header--pto {
  width: 90px;
}

@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }

  .main-header--pto {
    width: 200px;
  }
}

.main-header--free {
  width: 280px;
}

.button-container-blue {
  background: #275271;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}

.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}

.button-container--register {
  font-family: 'Fira Sans', sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}

.patient-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}

.button-container--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}

.button-container--arrow {
  margin-right: 20px;
}

.free-main-header--margin {
  margin-top: 100px;
}

.button-container--margin {
  margin-bottom: 30px;
}

.button-container--padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}

.videoWrapper {
  position: relative;
  width: 95%;
  left: 5%;
  top: 3%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}

.patients-container--download {
  text-decoration: none;
}

@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px;
  }

  .button-container--text {
    font-size: 26px;
  }
}

.patients-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.patients-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Patients.vue